import React, { useEffect, useState } from "react";
import {
  Card,
  Container,
  ContinueButton,
  ContinueButton2,
  ContractInput,
  Footer,
  Header,
  Option,
  Question,
  SearchContainer,
  SearchIcon,
  Select,
  WrapContent,
  WrapContractInfo,
} from "../../styles/TypeRegister";
import {
  errorContract,
  getClubs,
  getContractById,
  getContractInfo,
  setEnterpriseId,
  setIdContract,
  setNumberContract,
} from "../../data/services/crew_service";
import { useNavigate } from "react-router-dom";
import { MYCONTRACTS, PARTICULAR, PFFORM } from "../../core/app-urls";
import { BackButton } from "../../styles/AddAdherense";
import { FaArrowLeft } from "react-icons/fa";

export default function TypeRegister() {
  const [selectedOption, setSelectedOption] = useState("");
  const [contractNumber, setContractNumber] = useState("");
  const [error, setError] = useState<String>("");
  const [contractData, setContractData] = useState<any>(null);
  const [clubs, setClubs] = useState<any[]>([]);
  const [selectedClubId, setSelectedClubId] = useState<string>("");
  const [contracts, setContracts] = useState<any[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchClubs() {
      const { clubs } = await getClubs();
      setClubs(clubs);
    }
    fetchClubs();
    localStorage.removeItem("selectedClubId");
  }, []);

  const handleClubChange = async (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const clubId = event.target.value;
    setSelectedClubId(clubId);

    if (clubId) {
      localStorage.setItem("selectedClubId", clubId);
      const { contractById } = await getContractById(clubId);
      setContracts(contractById);
    } else {
      setContracts([]);
    }
  };

  const handleSearch = async () => {
    setError("");
    setContractData(null);

    try {
      if (!contractNumber) return;
      const { contract } = await getContractInfo(contractNumber);
      setNumberContract(contractNumber);
      setIdContract(contract?.idContrato!.toString()!);
      if (contract) {
        setEnterpriseId(contract.idAssociado!.toString());
        setContractData(contract);
      } else {
        setError(errorContract);
      }
    } catch (err: any) {
      setError(err.message || "Erro ao buscar contrato.");
    }
  };

  return (
    <Container>
      <WrapContent>
        <BackButton onClick={() => navigate(MYCONTRACTS)}>
          <FaArrowLeft />
          Voltar
        </BackButton>
        <Header>
          <h1>PORTAL DO CLIENTE</h1>
          <h3>Cadastro</h3>
        </Header>

        <Card>
          <Question>Qual modelo de adesão?</Question>
          <Option>
            <input
              type="radio"
              name="membership"
              value="convenio"
              checked={selectedOption === "convenio"}
              onChange={() => setSelectedOption("convenio")}
            />
            Convênio
          </Option>
          {/* <Option>
              <input
                type="radio"
                name="membership"
                value="particular"
                checked={selectedOption === "particular"}
                onChange={() => setSelectedOption("particular")}
              />
              Particular
            </Option> */}

          {selectedOption &&
            (selectedOption === "convenio" ? (
              <WrapContractInfo>
                <Question>Qual o código verificador do contrato?</Question>
                <SearchContainer>
                  <ContractInput
                    value={contractNumber}
                    onChange={(e) => setContractNumber(e.target.value)}
                  />
                  <SearchIcon onClick={handleSearch} />
                </SearchContainer>
                {error && <p style={{ color: "red" }}>{error}</p>}
                {contractData && (
                  <>
                    <h4>Empresa: {contractData.nomeFantasia}</h4>
                    <h4>CPF/CNPJ: {contractData.cnpj}</h4>
                    <ContinueButton onClick={() => navigate(PFFORM)}>
                      Continuar
                    </ContinueButton>
                  </>
                )}
              </WrapContractInfo>
            ) : (
              <WrapContractInfo>
                <Question>Selecione a unidade a que pertence:</Question>
                <Select onChange={handleClubChange} value={selectedClubId}>
                  <option value="">Selecione o clube</option>
                  {clubs.map((club: any) => (
                    <option key={club.id_clube} value={club.id_clube}>
                      {club.razao_social}
                    </option>
                  ))}
                </Select>
                {selectedClubId && (
                  <ContinueButton2 onClick={() => navigate(PARTICULAR)}>
                    Continuar
                  </ContinueButton2>
                )}
              </WrapContractInfo>
            ))}
        </Card>

        <Footer>Developed by WBC SISTEMAS</Footer>
      </WrapContent>
    </Container>
  );
}
